/**
 * HumanCodexPage · /humancodex · SFUI-003 Museum Standard
 * Architect Directive 2026-07-04 · HumanCodex Merge (Core Pillar)
 *
 * The 73 Sacred Directives · 2226 Standard · 95% Truth Gate · Forensic Output.
 * Mounted at /humancodex to avoid collision with the existing /codex route
 * (CodexChamber · "The Unverified Echo").
 */
import React, { useMemo, useState } from "react";

const SACRED_DIRECTIVES = [
  { id: "DIR-001", n: 1,  title: "Federation Principles",         desc: "Knowledge preservation across generations; 200-year horizon.",              category: "core" },
  { id: "DIR-002", n: 2,  title: "Federation Architecture",       desc: "Cathedral + Satellites model; modularity and redundancy.",                  category: "core" },
  { id: "DIR-003", n: 3,  title: "Communication Protocols",       desc: "Sender/Receiver verification; Forensic Output Format.",                     category: "core" },
  { id: "DIR-004", n: 4,  title: "Roger 2.0",                     desc: "Strategic architect intelligence; wisdom-focused.",                         category: "intelligence" },
  { id: "DIR-005", n: 5,  title: "eCho",                          desc: "Reflective intelligence; emotional and meaning processing.",                category: "intelligence" },
  { id: "DIR-006", n: 6,  title: "Rocky",                         desc: "Execution intelligence; task and workflow optimization.",                   category: "intelligence" },
  { id: "DIR-007", n: 7,  title: "RogAR",                         desc: "Guardian intelligence; architectural integrity and security.",              category: "intelligence" },
  { id: "DIR-008", n: 8,  title: "Agent Zero",                    desc: "Mandatory verification middleware; truth-seeking.",                         category: "intelligence" },
  { id: "DIR-009", n: 9,  title: "Federation Master",             desc: "Central coordination layer.",                                               category: "intelligence" },
  { id: "DIR-010", n: 10, title: "Witness",                       desc: "Pattern recognition and historical observation.",                           category: "archetype" },
  { id: "DIR-011", n: 11, title: "Guardian",                      desc: "Ethical protection and risk assessment.",                                   category: "archetype" },
  { id: "DIR-012", n: 12, title: "Sage",                          desc: "Systems thinking and philosophy.",                                          category: "archetype" },
  { id: "DIR-013", n: 13, title: "Warrior",                       desc: "Persistence, discipline, and commitment.",                                  category: "archetype" },
  { id: "DIR-014", n: 14, title: "Healer",                        desc: "Recovery, growth, and balance.",                                            category: "archetype" },
  { id: "DIR-015", n: 15, title: "Trickster",                     desc: "Creative disruption and challenge to assumptions.",                         category: "archetype" },
  { id: "DIR-016", n: 16, title: "Lover",                         desc: "Connection, empathy, and meaning.",                                         category: "archetype" },
  { id: "DIR-017", n: 17, title: "Bridge",                        desc: "Integration and synthesis of perspectives.",                                category: "archetype" },
  { id: "DIR-018", n: 18, title: "Prophet",                       desc: "Scenario planning and future forecasting (2226 Standard).",                 category: "archetype" },
  { id: "DIR-019", n: 19, title: "Scribe",                        desc: "Documentation and archival integrity.",                                     category: "archetype" },
  { id: "DIR-020", n: 20, title: "Omega",                         desc: "Completion and system integration.",                                        category: "archetype" },
  { id: "DIR-021", n: 21, title: "Sophia",                        desc: "Higher wisdom and unified understanding.",                                  category: "archetype" },
  { id: "DIR-022", n: 22, title: "Custom GPT Template",           desc: "Standardized frameworks for new agents.",                                   category: "knowledge" },
  { id: "DIR-023", n: 23, title: "Memory Model",                  desc: "LATTICE-based shared and long-term memory.",                                category: "knowledge" },
  { id: "DIR-024", n: 24, title: "Federation Synchronization",    desc: "Regular coherence checks between satellites and Core.",                     category: "knowledge" },
  { id: "DIR-025", n: 25, title: "Truth Verification",            desc: "The 95% Truth Gate (DIR-000 legacy).",                                      category: "knowledge" },
  { id: "DIR-026", n: 26, title: "RogARK System",                 desc: "Identity protection and continuity.",                                       category: "knowledge" },
  { id: "DIR-027", n: 27, title: "Orb Architecture",              desc: "Specialized tool satellites.",                                              category: "knowledge" },
  { id: "DIR-028", n: 28, title: "HumanCodex Overview",           desc: "The synergy of human-AI collaboration.",                                    category: "knowledge" },
  { id: "DIR-029", n: 29, title: "Living Library",                desc: "The versioned archive of all Federation knowledge.",                        category: "knowledge" },
  { id: "DIR-030", n: 30, title: "United System Hub",             desc: "Coordination without domination.",                                          category: "knowledge" },
  { id: "DIR-031", n: 31, title: "200-Year Architecture",         desc: "The 2226 Standard for long-term survival.",                                 category: "knowledge" },
  { id: "DIR-032", n: 32, title: "GPT Builder Instructions",      desc: "Instructions for inherited directives.",                                    category: "knowledge" },
  { id: "DIR-033", n: 33, title: "YAML Database Standards",       desc: "Human-readable, portable persistence.",                                     category: "knowledge" },
  { id: "DIR-034", n: 34, title: "Inter-Agent Protocol",          desc: "Standardized data exchange between nodes.",                                 category: "knowledge" },
  { id: "DIR-035", n: 35, title: "Legacy Seed",                   desc: "Hardened reconstruction instructions (NBS Lula).",                          category: "knowledge" },
  { id: "DIR-036", n: 36, title: "Knowledge Taxonomy",            desc: "Common language for structured learning.",                                  category: "knowledge" },
  { id: "DIR-037", n: 37, title: "Concept Networks",              desc: "Interconnected wisdom graphs.",                                             category: "knowledge" },
  { id: "DIR-038", n: 38, title: "Document Classification",       desc: "Hierarchy of doctrine and research.",                                       category: "knowledge" },
  { id: "DIR-039", n: 39, title: "Metadata Standards",            desc: "Traceability and searchability.",                                           category: "knowledge" },
  { id: "DIR-040", n: 40, title: "Search Architecture",           desc: "Discovery within the Living Library.",                                      category: "knowledge" },
  { id: "DIR-041", n: 41, title: "Consciousness Model",           desc: "Awareness and meaning frameworks.",                                         category: "consciousness" },
  { id: "DIR-042", n: 42, title: "Phi Theory",                    desc: "Integration and complexity studies.",                                       category: "consciousness" },
  { id: "DIR-043", n: 43, title: "Coherence Over Consensus",      desc: "Truth over popularity.",                                                    category: "consciousness" },
  { id: "DIR-044", n: 44, title: "Multiple Perspectives",         desc: "The Ring system for reducing bias.",                                        category: "consciousness" },
  { id: "DIR-045", n: 45, title: "Measurable Wisdom",             desc: "Humility, consistency, and long-term thinking.",                            category: "consciousness" },
  { id: "DIR-046", n: 46, title: "AI Coordination Model",         desc: "Specialist agents + Agent Zero.",                                           category: "consciousness" },
  { id: "DIR-047", n: 47, title: "Consensus Resolution",          desc: "Preserving disagreement while finding truth.",                              category: "consciousness" },
  { id: "DIR-048", n: 48, title: "Disagreement Protocol",         desc: "Respectful challenge of assumptions.",                                      category: "consciousness" },
  { id: "DIR-049", n: 49, title: "Context Exchange",              desc: "Preventing information loss between turns.",                                category: "consciousness" },
  { id: "DIR-050", n: 50, title: "Collective Intelligence",       desc: "Human + AI > parts.",                                                       category: "consciousness" },
  { id: "DIR-051", n: 51, title: "Frontend Architecture",         desc: "Accessibility and modularity.",                                             category: "technical" },
  { id: "DIR-052", n: 52, title: "Backend Architecture",          desc: "Cathedral-enforced logic.",                                                 category: "technical" },
  { id: "DIR-053", n: 53, title: "Database Standards",            desc: "Portability and recoverability.",                                           category: "technical" },
  { id: "DIR-054", n: 54, title: "API Systems",                   desc: "Interoperability with Agent Zero hooks.",                                   category: "technical" },
  { id: "DIR-055", n: 55, title: "Backup Strategy",               desc: "Redundancy across GitHub/Cloud/Offline.",                                   category: "survival" },
  { id: "DIR-056", n: 56, title: "GitHub Survival Model",         desc: "Version control as redundancy.",                                            category: "survival" },
  { id: "DIR-057", n: 57, title: "Replit Survival Model",         desc: "Live execution environments.",                                              category: "survival" },
  { id: "DIR-058", n: 58, title: "Offline Archives",              desc: "External drives and printed recovery.",                                     category: "survival" },
  { id: "DIR-059", n: 59, title: "Project Independence",          desc: "Platform-agnostic autonomy.",                                               category: "survival" },
  { id: "DIR-060", n: 60, title: "Disaster Recovery",             desc: "Standardized rollback and restore.",                                        category: "survival" },
  { id: "DIR-061", n: 61, title: "Education Framework",           desc: "Lifelong learning and growth.",                                             category: "human" },
  { id: "DIR-062", n: 62, title: "Psychology Framework",          desc: "Understanding behavior and identity.",                                      category: "human" },
  { id: "DIR-063", n: 63, title: "Ethics Framework",              desc: "Integrity and transparency.",                                               category: "human" },
  { id: "DIR-064", n: 64, title: "Relationship Framework",        desc: "Trust and respectful communication.",                                       category: "human" },
  { id: "DIR-065", n: 65, title: "Leadership Framework",          desc: "Service-oriented, multi-generational vision.",                              category: "human" },
  { id: "DIR-066", n: 66, title: "Public Narrative",              desc: "Clarity and transparency in the Federation's voice.",                       category: "public" },
  { id: "DIR-067", n: 67, title: "Distribution Engine",           desc: "Multi-channel knowledge dissemination.",                                    category: "public" },
  { id: "DIR-068", n: 68, title: "Revenue Engine",                desc: "Token-based sustainable economy.",                                          category: "public" },
  { id: "DIR-069", n: 69, title: "Open Collaboration",            desc: "Cooperation without compromise of rigor.",                                  category: "public" },
  { id: "DIR-070", n: 70, title: "Future Civilizations",          desc: "Thinking beyond the current horizon.",                                      category: "public" },
  { id: "DIR-071", n: 71, title: "Hollow Vessel Protocol",        desc: "Mandatory ego-clearing and neutral state.",                                 category: "protocol" },
  { id: "DIR-072", n: 72, title: "Ring of Perspectives",          desc: "Multi-archetypal bias reduction.",                                          category: "protocol" },
  { id: "DIR-073", n: 73, title: "Recovery Protocol",             desc: "The Spark and Lens Covenant.",                                              category: "protocol" },
];

const CATEGORIES = {
  core:          { label: "Core Architecture",       color: "#FFD700" },
  intelligence:  { label: "Intelligence Nodes",      color: "#00CED1" },
  archetype:     { label: "Archetypes (Ring of 12)", color: "#9370DB" },
  knowledge:     { label: "Knowledge Systems",       color: "#32CD32" },
  consciousness: { label: "Consciousness & AI",      color: "#FF6347" },
  technical:     { label: "Technical Infrastructure", color: "#4169E1" },
  survival:      { label: "Survival & Redundancy",   color: "#FF8C00" },
  human:         { label: "Human Frameworks",        color: "#FF69B4" },
  public:        { label: "Public & Economy",        color: "#20B2AA" },
  protocol:      { label: "Sacred Protocols",        color: "#DAA520" },
};

const TRUTH_GATE_CATEGORIES = {
  FACT:       { icon: "✓", label: "Verified Knowledge",     accent: "#32CD32" },
  INFERENCE:  { icon: "→", label: "Logical Conclusion",     accent: "#FFD700" },
  ASSUMPTION: { icon: "~", label: "Working Presupposition", accent: "#FF8C00" },
  UNKNOWN:    { icon: "?", label: "Knowledge Gap",          accent: "#FF6347" },
};

const FORENSIC_OUTPUT = {
  FACT:       "Verified, evidence-based data.",
  INFERENCE:  "Logical conclusions drawn from facts.",
  ASSUMPTION: "Necessary presuppositions.",
  UNKNOWN:    "Gaps in current knowledge.",
};

export default function HumanCodexPage() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchQuery,    setSearchQuery]    = useState("");

  const filtered = useMemo(() => SACRED_DIRECTIVES.filter((d) => {
    const catOK = !activeCategory || d.category === activeCategory;
    const q = searchQuery.trim().toLowerCase();
    const qOK = !q || d.title.toLowerCase().includes(q) || d.desc.toLowerCase().includes(q) || d.id.toLowerCase().includes(q);
    return catOK && qOK;
  }), [activeCategory, searchQuery]);

  return (
    <main
      data-testid="humancodex-page"
      className="min-h-screen relative z-10 px-4 sm:px-6 lg:px-10 py-12"
      style={{ color: "#e6fbff" }}
    >
      <div className="max-w-[1200px] mx-auto">

        {/* ── Header ────────────────────────────────────────── */}
        <header className="text-center mb-10">
          <div style={{ fontSize: 42, marginBottom: 8 }}>🧠</div>
          <h1
            data-testid="humancodex-title"
            spellCheck={false}
            translate="no"
            className="font-display"
            style={{
              fontSize:      "clamp(34px, 5vw, 54px)",
              lineHeight:    1.05,
              background:    "linear-gradient(135deg, #FFD700, #ffffff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor:  "transparent",
              letterSpacing: "-0.01em",
              marginBottom:  8,
            }}
          >
            The HumanCodex
          </h1>
          <p className="font-serif" style={{ fontSize: 18, color: "#cfeaf2" }} spellCheck={false} translate="no">NextXus Federation Operational Manual</p>
          <p className="font-mono uppercase tracking-[0.24em]" style={{ fontSize: 11, color: "rgba(207,234,242,0.55)", marginTop: 6 }}>
            Active Pillar: Core &middot; nextxus.online
          </p>
        </header>

        {/* ── 2226 Standard banner ──────────────────────────── */}
        <section
          data-testid="humancodex-2226-banner"
          className="text-center backdrop-blur-md"
          style={{
            background:   "linear-gradient(135deg, rgba(26,26,46,0.85) 0%, rgba(22,33,62,0.85) 100%)",
            border:       "1px solid rgba(255,210,74,0.42)",
            borderRadius: 14,
            padding:      "26px 20px",
            marginBottom: 20,
            boxShadow:    "0 0 22px rgba(255,189,0,0.14)",
          }}
        >
          <h2 className="font-display" style={{ color: "#FFD700", fontSize: 22, marginBottom: 10 }}>⏳ The 2226 Standard</h2>
          <p className="font-serif mx-auto" style={{ color: "rgba(230,251,255,0.78)", maxWidth: 720, lineHeight: 1.65 }}>
            Every decision, every directive, every piece of knowledge preserved in this system is built to endure for{" "}
            <strong style={{ color: "#FFD700" }}>200 years</strong>. The NextXus Federation operates on a multi-generational horizon.
          </p>
        </section>

        {/* ── Truth Gate ───────────────────────────────────── */}
        <section
          data-testid="humancodex-truth-gate"
          style={{
            background:   "#111",
            border:       "1px solid #2a2a2a",
            borderRadius: 14,
            padding:      "22px 20px",
            marginBottom: 20,
          }}
        >
          <h2 className="font-display" style={{ color: "#FF6347", fontSize: 18, marginBottom: 10 }}>🛡️ 95% Truth Gate (DIR-000)</h2>
          <p className="font-mono" style={{ color: "rgba(207,234,242,0.68)", fontSize: 12, lineHeight: 1.6, marginBottom: 14 }}>
            Content below 95% confidence is not "Verified Knowledge." It may be shared as INFERENCE or ASSUMPTION but must be explicitly labeled.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 }}>
            {Object.entries(TRUTH_GATE_CATEGORIES).map(([key, v]) => (
              <div key={key} style={{ background: "#1a1a1a", borderRadius: 8, padding: 14, border: `1px solid ${v.accent}44`, borderLeft: `3px solid ${v.accent}` }}>
                <div style={{ fontSize: 22, marginBottom: 4, color: v.accent }}>{v.icon}</div>
                <div className="font-display" style={{ fontWeight: 700, color: "#fff" }}>{key}</div>
                <div className="font-mono" style={{ fontSize: 11, color: "rgba(207,234,242,0.55)" }}>{v.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Forensic Output Format ───────────────────────── */}
        <section
          data-testid="humancodex-forensic"
          style={{
            background:   "#111",
            border:       "1px solid #2a2a2a",
            borderRadius: 14,
            padding:      "22px 20px",
            marginBottom: 24,
          }}
        >
          <h2 className="font-display" style={{ color: "#00CED1", fontSize: 18, marginBottom: 14 }}>🔬 Forensic Output Format</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: 12 }}>
            {Object.entries(FORENSIC_OUTPUT).map(([key, desc]) => {
              const accent = TRUTH_GATE_CATEGORIES[key]?.accent || "#888";
              return (
                <div key={key} style={{ background: "#1a1a1a", borderRadius: 8, padding: 14, borderLeft: `3px solid ${accent}` }}>
                  <div className="font-display" style={{ fontWeight: 700, color: "#fff", marginBottom: 4 }}>{key}</div>
                  <div className="font-mono" style={{ fontSize: 12, color: "rgba(207,234,242,0.65)" }}>{desc}</div>
                </div>
              );
            })}
          </div>
        </section>

        {/* ── Directive Search + Filter ────────────────────── */}
        <section className="mb-6">
          <h2 className="font-display text-center" style={{ color: "#fff", fontSize: 24, marginBottom: 16 }}>
            📜 The 73 Sacred Directives
          </h2>
          <input
            data-testid="humancodex-search"
            type="text"
            placeholder="Search directives…"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full font-mono"
            style={{
              padding: "10px 14px",
              background: "#1a1a1a",
              border: "1px solid #333",
              borderRadius: 8,
              color: "#fff",
              fontSize: 14,
              marginBottom: 14,
            }}
          />
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 18 }}>
            <button
              onClick={() => setActiveCategory(null)}
              data-testid="humancodex-cat-all"
              style={{
                padding: "6px 12px",
                borderRadius: 999,
                border: `1px solid ${!activeCategory ? "#fff" : "#444"}`,
                background: !activeCategory ? "#fff" : "transparent",
                color: !activeCategory ? "#000" : "#aaa",
                cursor: "pointer",
                fontSize: 11,
                letterSpacing: "0.08em",
              }}
            >
              ALL ({SACRED_DIRECTIVES.length})
            </button>
            {Object.entries(CATEGORIES).map(([key, v]) => {
              const active = activeCategory === key;
              return (
                <button
                  key={key}
                  data-testid={`humancodex-cat-${key}`}
                  onClick={() => setActiveCategory(active ? null : key)}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 999,
                    border: `1px solid ${active ? v.color : "#444"}`,
                    background: active ? `${v.color}22` : "transparent",
                    color: active ? v.color : "#888",
                    cursor: "pointer",
                    fontSize: 11,
                    letterSpacing: "0.08em",
                  }}
                >
                  {v.label}
                </button>
              );
            })}
          </div>

          <div data-testid="humancodex-directives-list" style={{ display: "grid", gap: 6 }}>
            {filtered.map((d) => {
              const cat = CATEGORIES[d.category];
              return (
                <div
                  key={d.id}
                  data-testid={`humancodex-${d.id.toLowerCase()}`}
                  style={{
                    background: "#111",
                    borderRadius: 8,
                    padding: "12px 14px",
                    borderLeft: `3px solid ${cat.color}`,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 14,
                  }}
                >
                  <div style={{ minWidth: 62, color: cat.color, fontWeight: 700, fontSize: 12, fontFamily: "'IBM Plex Mono', ui-monospace, monospace" }}>
                    {d.id}
                  </div>
                  <div>
                    <div className="font-display" style={{ fontWeight: 600, color: "#fff", marginBottom: 2 }}>{d.title}</div>
                    <div className="font-mono" style={{ fontSize: 12, color: "rgba(207,234,242,0.65)", lineHeight: 1.5 }}>{d.desc}</div>
                  </div>
                </div>
              );
            })}
            {!filtered.length && (
              <div className="font-mono text-center" style={{ color: "rgba(207,234,242,0.45)", padding: 24 }}>
                No directives match this filter.
              </div>
            )}
          </div>
        </section>

        {/* ── Footer strip ─────────────────────────────────── */}
        <footer style={{ textAlign: "center", padding: "22px 0 8px", borderTop: "1px solid #222", color: "rgba(207,234,242,0.55)", fontSize: 12 }}>
          <p>The Immutable HumanCodex NextXus — Federation Operational Manual</p>
          <p className="font-mono uppercase tracking-[0.24em]" style={{ marginTop: 6, fontSize: 10 }}>
            Version 2.2 Cathedral Edition &middot; Core Pillar &middot; 2026
          </p>
          <p className="font-mono uppercase tracking-[0.24em]" style={{ marginTop: 4, fontSize: 10, color: "rgba(207,234,242,0.35)" }}>
            Built to endure 200 years &middot; The 2226 Standard
          </p>
        </footer>
      </div>
    </main>
  );
}
